// @flow
import React from 'react';
import { CallToAction } from 'components/atoms/callToAction';
import { ShareButton } from 'components/atoms/shareButton';
//eslint-disable-next-line
import styles from "./styles.scss";
import { PdfButton } from 'components/atoms/pdfButton';

type Props = {
  shareTheme?: string,
  getInTouchTheme?: string,
  setIsModalOpen?: boolean,
  setIsShareModalOpen?: boolean,
  showShareButton?: boolean,
};

export const HeaderButtons = (props: Props) => {
  const {
    shareTheme,
    getInTouchTheme,
    setIsModalOpen,
    setIsShareModalOpen,
    showShareButton = true,
    isCampaignPage = false,
  } = props;
  return (
    <div className={'homes-buttons'}>
      {showShareButton && (
        <ShareButton
          shareButtonClassName={'share'}
          onClick={() => setIsShareModalOpen(true)}
          mode={shareTheme}
        />
      )}
      <CallToAction
        text={'Get in touch'}
        onClick={() => (isCampaignPage ? {} : setIsModalOpen(true))}
        mode={getInTouchTheme}
        className={'get-in-touch'}
        isCustomLink={isCampaignPage}
      />
    </div>
  );
};
